import {
    logIn,
    logOut,
    userGetAll,
    userGetAllForSearch,
    loginFacebook,
    registerGymAccount,
    registerUserAccount,
    forgotPassword,
    updatePassword,
    getUserPreferences,
    bookedUsersRequest,
    deleteUserAccount,
} from './userRequestConfigs';
import { getProfile } from '../ProfileApi/profileRequestConfigs';

class UserApi {
    getAuthenticatedUser = getProfile;
    logIn = logIn;
    logOut = logOut;
    getAll = userGetAll;
    getAllForSearch = userGetAllForSearch;
    loginFacebook = loginFacebook;
    registerGymAccount = registerGymAccount;
    registerUserAccount = registerUserAccount;
    forgotPassword = forgotPassword;
    updatePassword = updatePassword;
    getUserPreferences = getUserPreferences;
    bookedUsersRequest = bookedUsersRequest;
    deleteUserAccount = deleteUserAccount;
}

class UserFactory {
    user = UserApi;
    create() {
        return new this.user();
    }
}

export const user = new UserFactory();



// WEBPACK FOOTER //
// ./src/BusinessLogic/Network/API/UserApi/index.js